import React, { useState, useContext, FC } from 'react';

import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Configure } from 'react-instantsearch-dom';
import { useLocation } from 'react-router-dom';

import { DiscoverContext } from '../../../../context/DiscoverContext';
import { LearnerInfo } from '../../../../types';
import { LIST_VIEW } from '../../const';
import EmptyState from '../EmptyState';
import { InfiniteHits as CustomInfiniteHits } from '../InfiniteHits';
import { SearchResults } from '../SearchResults';
import useStyles from './styles';

interface ResultsPanelProps {
  userInfo?: LearnerInfo;
  tenantTitle?: string | null;
  tenantName?: string | null;
  linkedInId?: string | null;
}

const ResultsPanel: FC<ResultsPanelProps> = ({ userInfo, tenantTitle, tenantName, linkedInId }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { discoverView, searchState } = useContext(DiscoverContext);

  const location = useLocation();
  const search = location?.search;

  const limit = search === '?all' ? 150 : discoverView === LIST_VIEW ? 25 : 24;
  const [itemsCount, setItemsCount] = useState<null | number>(null);
  const [page, setPage] = useState<null | number>(null);

  const resultsFunc = (count) => {
    return (
      <>
        {count > 1 || !count ? t('page.discover.results') : t('page.discover.result')}
        {searchState?.query ? ` ${t('page.discover.for')} "${searchState.query}"` : null}
      </>
    );
  };

  return (
    <Box className={classes.resultsPanel}>
      <Configure hitsPerPage={limit} enablePersonalization />
      <SearchResults
        setItemsCount={setItemsCount}
        setPage={setPage}
        resultsFunc={resultsFunc}
        withToggle
      />
      <CustomInfiniteHits
        total={itemsCount}
        page={page}
        limit={limit}
        view={discoverView}
        userInfo={userInfo}
        tenantTitle={tenantTitle}
        tenantName={tenantName}
        linkedInId={linkedInId}
      />
      {itemsCount === 0 && <EmptyState withSubTitle />}
    </Box>
  );
};

export default ResultsPanel;
